import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {DeliveryPointService} from "@app/presentation/services/delivery-point/delivery-point.service";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatBottomSheetModule
  ],
  providers: [
    DeliveryPointService
  ]
})
export class DeliveryPointServiceModule { }
